// extracted by mini-css-extract-plugin
module.exports = {"button":"nN5Y9","buttonPicDiv":"_3w_zS","buttonXDiv":"_1OZfK"};